import { Button, ButtonVariant } from "@repo/ui/Buttons/button";
import { Input } from "@repo/ui/Inputs/input";
import { showToast, ToastVariant } from "@repo/ui/toast/toast";
import { type FC, useState } from "react";
import { useNavigate } from "react-router";
import { useCreateKnowledgeBaseMutation } from "../../../api/entities/knowledgeBase.js";
import { appPaths } from "../../../app/appPaths.js";

interface KnowledgeBaseCreateFormProps {
  close: () => void;
}

export const KnowledgeBaseCreateForm: FC<KnowledgeBaseCreateFormProps> = ({
  close,
}) => {
  const navigate = useNavigate();

  const [name, setName] = useState("");
  const [createKnowledgeBase, { isLoading }] = useCreateKnowledgeBaseMutation();

  const handleCreate = async () => {
    if (!name.trim()) {
      return;
    }

    try {
      const newKnowledgeBase = await createKnowledgeBase({ name }).unwrap();
      showToast({
        title: "Knowledge base created successfully",
        variant: ToastVariant.Success,
      });
      close();
      navigate(
        appPaths.settingsKnowledgeBase.build({
          knowledgeBaseId: newKnowledgeBase.id,
        }),
      );
    } catch (error) {
      showToast({
        title: "Failed to create knowledge base",
        variant: ToastVariant.Error,
      });
    }
  };

  return (
    <div className="mt-4 flex w-[500px] flex-col space-y-3">
      <Input
        id="knowledge-base-name"
        label="Name"
        value={name}
        onChange={(e) => setName(e.target.value)}
        placeholder="Enter knowledge base name"
        maxLength={100}
      />

      <div className="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
        <div className="ml-3">
          <Button
            variant={ButtonVariant.Primary}
            onClick={handleCreate}
            isDisabled={!name.trim() || isLoading}
            isLoading={isLoading}
          >
            Create
          </Button>
        </div>
        <Button
          variant={ButtonVariant.Secondary}
          onClick={close}
          isDisabled={isLoading}
        >
          Cancel
        </Button>
      </div>
    </div>
  );
};
